import { useParamsSearch } from '@anytag/shared-hooks';
import { TikTokCampaignsSearchType } from '../schemaTypes';

export const useTikTokCampaignsFilter = () => useParamsSearch<TikTokCampaignsSearchType>();
